const initialState = {
    amount: '',
};
const charge_wallet = (state = initialState, action) => {
    switch (action.type) {
        case 'CHANGE_DATA_PAGE_CHARGE_WALLET':
            return {...state, [action.name]: action.value};
        default:
            return state;
    }
};

export default charge_wallet;
